import { LISTING_STATUS } from '../../../config/constants';
import { Listing } from '../../../data/types/listings';

export function canChangeStockAndPrice(listing: Listing): boolean {
  return (
    listing.listing_status_num === LISTING_STATUS.listed ||
    listing.listing_status_num === LISTING_STATUS.category_hidden ||
    listing.listing_status_num === LISTING_STATUS.freezed_by_seller ||
    listing.listing_status_num === LISTING_STATUS.freezed_by_management ||
    listing.listing_status_num === LISTING_STATUS.approved
  );
}
